import React, {useState, useEffect} from "react";
import { useLanguage } from '../../../hooks/useLanguage';
import SubBanner from "../../../components/SubBanner";
import bannerImg from '../../../assets/img/trader_banner.png';
import AceExchanges from '../../../assets/img/Logo_ADLIB_White.svg';
import ex_ad from "../../../assets/img/ex_ad.png";
import subLast from "../../../assets/img/sub_last.png";
import ace_ad from "../../../assets/img/ace_ad.svg";
import ad_1 from "../../../assets/img/ad_1.png";
import ad_2 from "../../../assets/img/ad_2.png";
import ad_3 from "../../../assets/img/ad_3.png";
import ad_4 from "../../../assets/img/ad_4.png";
import sub_01 from "../../../assets/icon/sub_ad_01.svg";
import sub_02 from "../../../assets/icon/sub_ad_02.svg";
import sub_03 from "../../../assets/icon/sub_ad_03.svg";
import sub_04 from "../../../assets/icon/sub_ad_04.svg";
import ad_premium from "../../../assets/img/ad_premium.png";

import logo_press_1 from "../../../assets/img/logo_press_1.png";
import logo_press_2 from "../../../assets/img/logo_press_2.png";
import logo_press_3 from "../../../assets/img/logo_press_3.png";
import logo_press_4 from "../../../assets/img/logo_press_4.png";
import logo_press_5 from "../../../assets/img/logo_press_5.png";
import logo_press_6 from "../../../assets/img/logo_press_6.png";
import logo_press_7 from "../../../assets/img/logo_press_7.png";
import logo_press_8 from "../../../assets/img/logo_press_8.png";
import logo_press_9 from "../../../assets/img/logo_press_9.png";
import logo_press_10 from "../../../assets/img/logo_press_10.png";
import logo_press_11 from "../../../assets/img/logo_press_11.png";
import logo_press_12 from "../../../assets/img/logo_press_12.png";
import logo_press_13 from "../../../assets/img/logo_press_13.png";
import logo_press_14 from "../../../assets/img/logo_press_14.png";
import logo_press_15 from "../../../assets/img/logo_press_15.png";
import logo_press_16 from "../../../assets/img/logo_press_16.png";

import logo_n_press_1 from "../../../assets/img/logo_n_press_1.png";
import logo_n_press_2 from "../../../assets/img/logo_n_press_2.png";
import logo_n_press_3 from "../../../assets/img/logo_n_press_3.png";
import logo_n_press_4 from "../../../assets/img/logo_n_press_4.png";
import logo_n_press_5 from "../../../assets/img/logo_n_press_5.png";
import logo_n_press_6 from "../../../assets/img/logo_n_press_6.png";
import logo_n_press_7 from "../../../assets/img/logo_n_press_7.png";
import logo_n_press_8 from "../../../assets/img/logo_n_press_8.png";
import logo_n_press_9 from "../../../assets/img/logo_n_press_9.png";
import logo_n_press_10 from "../../../assets/img/logo_n_press_10.png";
import logo_n_press_11 from "../../../assets/img/logo_n_press_11.png";
import logo_n_press_12 from "../../../assets/img/logo_n_press_12.png";

import logo_app_1 from "../../../assets/img/logo_app_1.png";
import logo_app_2 from "../../../assets/img/logo_app_2.png";
import logo_app_3 from "../../../assets/img/logo_app_3.png";
import logo_app_4 from "../../../assets/img/logo_app_4.png";
import logo_app_5 from "../../../assets/img/logo_app_5.png";
import logo_app_6 from "../../../assets/img/logo_app_6.png";
import logo_app_7 from "../../../assets/img/logo_app_7.png";
import logo_app_8 from "../../../assets/img/logo_app_8.png";
import logo_app_9 from "../../../assets/img/logo_app_9.png";
import logo_app_10 from "../../../assets/img/logo_app_10.png";
import logo_app_11 from "../../../assets/img/logo_app_11.png";
import logo_app_12 from "../../../assets/img/logo_app_12.png";

import logo_ctv_1 from "../../../assets/img/logo_ctv_1.png";
import logo_ctv_2 from "../../../assets/img/logo_ctv_2.png";
import logo_ctv_3 from "../../../assets/img/logo_ctv_3.png";
import logo_ctv_4 from "../../../assets/img/logo_ctv_4.png";

import { ATTACHMENT_URL } from "../../../utils/urls";
import instance from "../../../services/services";

function Adlib(){
  const { t } = useLanguage();
   // 0: ACE Trader, 1: ACE eXchange, 2: ADLIB
  const [activeTab, setActiveTab] = useState(2);
  const [adlibData, setAdlibData] = useState([]);

  const tabList = [
    { label: "ACE Trader", url: "/solutions/aceTrader" },
    { label: "ACE eXchange", url: "/solutions/aceExchange" },
    { label: "ACE ADLIB", url: "/solutions/adlib" },
  ];

  //광고
  const aceAdlibTargets = t('sub_section_4.aceAdlib_targets', []);
  const targetBox = aceAdlibTargets.map((item, idx) => ({
    ...item,
    img: [sub_01, sub_02, sub_03, sub_04][idx],
    num: `0${idx + 1}`,
  }));

  // 언론사 로고
  const pressLogo = [
    {img:logo_press_1},
    {img:logo_press_2},
    {img:logo_press_3},
    {img:logo_press_4},
    {img:logo_press_5},
    {img:logo_press_6},
    {img:logo_press_7},
    {img:logo_press_8},
    {img:logo_press_9},
    {img:logo_press_10},
    {img:logo_press_11},
    {img:logo_press_12},
    {img:logo_press_13},
    {img:logo_press_14},
    {img:logo_press_15},
    {img:logo_press_16},
  ]
  // app 로고
  const appLogo = [
    {img:logo_app_1},
    {img:logo_app_2},
    {img:logo_app_3},
    {img:logo_app_4},
    {img:logo_app_5},
    {img:logo_app_6},
    {img:logo_app_7},
    {img:logo_app_8},
    {img:logo_app_9},
    {img:logo_app_10},
    {img:logo_app_11},
    {img:logo_app_12},
  ]
    // 비언론사 로고
    const nPressLogo = [
      {img:logo_n_press_1},
      {img:logo_n_press_2},
      {img:logo_n_press_3},
      {img:logo_n_press_4},
      {img:logo_n_press_5},
      {img:logo_n_press_6},
      {img:logo_n_press_7},
      {img:logo_n_press_8},
      {img:logo_n_press_9},
      {img:logo_n_press_10},
      {img:logo_n_press_11},
      {img:logo_n_press_12},
    ]

    // ctv 로고
    const ctvLogo = [
      {img:logo_ctv_1},
      {img:logo_ctv_2},
      {img:logo_ctv_3},
      {img:logo_ctv_4},
    ]

    useEffect(()=> {
      const fetchAttachment = async () => {
        try {
          const response = await instance.post(ATTACHMENT_URL)
          setAdlibData(response.data.data.adlib);
        }
        catch(error) {
          console.error('첨부파일 데이터 가져오기 실패:', error);
        }
      }
      fetchAttachment();
    }, []);

  
  return(
    <div className="solutions">
    {/* 배너 */}
      <SubBanner
        bgImg={bannerImg}
        logoImg={AceExchanges}
        description={
          <span
            dangerouslySetInnerHTML={{
              __html: t('aceAdlib.descriptionHtml')
            }}
          />
        }
        buttons={[
          { label: t('aceAdlib.btn_1'), url: `https://admin.nhnace.com${adlibData?.file_path}` },
          { label: t('aceAdlib.btn_2'), url: "https://mkt.adlibr.com/login" }
        ]}
        tabs={tabList.map((tab,idx) => ({
          label : tab.label,
          url : tab.url,
          active: activeTab === idx,
          onClick: () => setActiveTab(idx),
        }))}
        location={[
          { label: "Solution", url: "/solution" },
          { label: "ADLIB", url: "/solution/adlib", active: true }
        ]}
      />

      <section className="sub_section mt-[190px] mb-[120px] md:mb-[160px] md:mt-[260px] mx-auto">
        <div className="sub_txt_box">
          <figure><img src={ace_ad} alt="ace_ad"/></figure>
          <span className="mt-[8px]">{t('sub_section_1.aceAdlib_desc')}</span>
          <p dangerouslySetInnerHTML={{ __html: t('sub_section_1.aceAdlib_con') }} />
        </div>
      </section>


      <section className="md:mt-[240px] mx-auto bg_gray" >
        <div className="sub_txt_box">
          <h3 className="f_40">{t('sub_section_2.aceAdlib_title')}</h3>
          <span className="mt-[10px]" dangerouslySetInnerHTML={{ __html: t('sub_section_2.aceAdlib_desc') }} />
        </div>

        <div className="partner_container mx-auto mt-[80px] lg:mt-[120px]">
            <figure className="m-auto">
              <img src={ex_ad} alt="ex_ad" loading="lazy"/>
            </figure>
        </div>
      </section>

      <section className="sub_section mt-[120px] md:mt-[160px] md-[120px] mx-auto">
        <div className="sub_txt_box">
        <h3 className="f_40">{t('sub_section_3.aceAdlib_title')}</h3>
        <span className="mt-[10px]" dangerouslySetInnerHTML={{ __html: t('sub_section_3.aceAdlib_desc') }} />
        </div>
        <div className="ad_container mt-[50px] md:mt-[80px] mx-auto mb-auto">
          <ul>
            <li>
              <img src={ad_1} alt="ad_1"/>
            </li>
            <li>
              <img src={ad_2} alt="ad_2"/>
            </li>
            <li>
              <img src={ad_3} alt="ad_3"/>
            </li>
            <li>
              <img src={ad_4} alt="ad_4"/>
            </li>
          </ul>
        </div>
      </section>


      <section className="mb-[120px] md:mb-[160px] mx-auto bg_gray" >
        <div className="sub_txt_box">
        <h3 className="f_40">{t('sub_section_4.aceAdlib_title')}</h3>
        <span className="mt-[10px]" dangerouslySetInnerHTML={{ __html: t('sub_section_4.aceAdlib_desc') }} />
        </div>
        <div className="target_container mt-[50px] md:mt-[80px] lg:mt-[120px] mx-auto mb-auto">
          <ul>
            {targetBox.map((target,idx) => (
              <li  className="target_box" key={idx}>
                <div className="t_top">
                  <img src={target.img} alt={`sub_0${idx+1}`}/>
                  <span>{target.num}</span>
                </div>
                <h4>{target.title}</h4>
                <p>{target.txt}</p>
              </li>
            ))}
          </ul>
        </div>
      </section>

      <section className="mb-[120px] mb:mb-[160px] mx-auto" >
        <div className="sub_txt_box max-w-[1624px] px-[20px] m-auto">
        <h3 className="f_40">{t('sub_section_5.aceAdlib_title')}</h3>
        <span className="mt-[10px]" dangerouslySetInnerHTML={{ __html: t('sub_section_5.aceAdlib_desc') }} />
        </div>

        <div className="mx-auto">
            <figure className="m-auto">
              <img src={ad_premium} alt="ad_premium" loading="lazy"/>
            </figure>
        </div>
      </section>

      <section className="mb-[120px] md:mb-[160px] mx-auto ad_page_bg">
        <div className="sub_txt_box max-w-[1624px] px-[20px] m-auto">
        <h3 className="f_40 text-white">{t('sub_section_6.aceAdlib_title')}</h3>
        <span className="mt-[10px]" dangerouslySetInnerHTML={{ __html: t('sub_section_6.aceAdlib_desc') }} />
        </div>

        <div className="ad_global"></div>
      </section>

      
      <section className="sub_section  mx-auto mb-[120px]">
        <div className="sub_txt_box">
        <h3 className="f_40">{t('sub_section_7.aceAdlib_title')}</h3>
        <span className="mt-[10px]" dangerouslySetInnerHTML={{ __html: t('sub_section_7.aceAdlib_desc') }} />
        </div>

        <div className="logo_map_container mt-[50px] md:mt-[120px] mx-auto mb-auto">
          <p className="red_btn_txt">WEB (pc/mobile)</p>
          <div>
            <span className="logo_ad_txt mt-[20px]">{t('sub_section_7.n_pub')}</span>
            <ul className="logo_map">
              {pressLogo.map((logo,idx)=>(
                <li key={idx}>
                  <img src={logo.img} alt="logo"/>
                </li>
              ))}
            </ul>
          </div>
          <div>
            <span className="logo_ad_txt mt-[60px]">{t('sub_section_7.g_pub')}</span>
            <ul className="logo_map">
              {nPressLogo.map((logo,idx)=>(
                <li key={idx}>
                  <img src={logo.img} alt="logo"/>
                </li>
              ))}
            </ul>
          </div>
        </div>
        <div className="logo_map_container mt-[50px] md:mt-[120px] mx-auto mb-auto">
          <p className="red_btn_txt">APP</p>
          <ul className="logo_map">
            {appLogo.map((logo,idx)=>(
              <li key={idx}>
                <img src={logo.img} alt="logo"/>
              </li>
            ))}
          </ul>
        </div>
        <div className="logo_map_container mt-[50px] md:mt-[120px] mx-auto mb-auto">
          <p className="red_btn_txt">CTV (IPTV/FAST)</p>
          <ul className="logo_map">
            {ctvLogo.map((logo,idx)=>(
              <li key={idx}>
                <img src={logo.img} alt="logo"/>
              </li>
            ))}
          </ul>
        </div>
      </section>

      <section className="sub_last">
        <div className="sub_last_inner">
          <div className="sub_left">
            <h3 className="f_40 text-left" dangerouslySetInnerHTML={{ __html: t('common_section.common_title') }} />
            <div className="banner_btn">
              <a
                href={`https://admin.nhnace.com${adlibData?.file_path}`}
                target="_blank"
                rel="noopener noreferrer"
              >
                {t('aceAdlib.btn_1')}
              </a>
              <a
                href="http://pubcenter.toast.com/"
                target="_blank"
                rel="noopener noreferrer"
              >
                {t('aceAdlib.btn_2')}
              </a>
            </div>
          </div>
          
          <div className="sub_right">
            <img src={subLast} alt="subLast" loading="lazy"/>
          </div>
        </div>
      </section>
    </div>
  )
};

export default Adlib;
